/* src/app/private/components/admission/bulk-delete-admission/bulk-delete-admission.component.scss */
/*# sourceMappingURL=bulk-delete-admission.component.css.map */
